import queryString from 'query-string';
import axios, { baseUrl } from './axios';

export default {
  getListOnlineService: async (options = {}) => {
    const params = queryString.stringify(options.filter);
    const result = await axios.get(
      `${baseUrl}/customer/pob/online_services${params ? `?${params}` : ''}`,
    );
    return result.data;
  },
};
